
export default {
  name: 'FiveStarProductsAwardInsurerSection',

  props: {
    categoryData: {
      type: Array,
      default: () => ([]),
    },
  },

  data() {
    return { 
    }
  },
  computed: {
  },
  methods: {
  },
}
